import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
const mainReviews = [{
  name: 'Valeria M.',
  role: 'Terapeuta holística',
  city: 'Buenos Aires',
  text: 'Llevaba meses queriendo estudiar biodecodificación pero los cursos me parecían carísimos. Con este Pack encontré todo lo que necesitaba y más.'
}, {
  name: 'Luciana F.',
  role: 'Comunicadora',
  city: 'Rosario',
  text: 'Soy comunicadora y quería emprender como terapeuta. La guía de marketing me cambió todo.'
}, {
  name: 'Carla R.',
  role: 'Estudiante',
  city: 'Córdoba',
  text: 'Empecé sin saber casi nada. Ahora estoy estudiando Reiki, chakras y registros akáshicos. No puedo creer que esté todo en un solo lugar.'
}, {
  name: 'Martina S.',
  role: 'Emprendedora',
  city: 'Tucumán',
  text: 'Lo recomendé a tres amigas que también lo compraron. Es completísimo.'
}];
const shortReviews = ['Parece una formación entera', 'Solo los bonus ya valen el precio', 'Lo tengo en el celular y lo consulto todo el tiempo', 'Me ayudó a ordenar mi camino espiritual'];
export function SocialProofSection() {
  return <section className="py-12 bg-gray-50 border-y border-gray-100" data-id="element-179">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-serif font-bold text-center text-black mb-10" data-id="element-181">
          Ellas ya lo tienen.{' '}
          <span className="italic text-terracotta" data-id="element-182">Leé lo que dicen.</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-183">
          {mainReviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-5 md:p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-184">
              <div className="flex text-gold mb-3" data-id="element-185">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 fill-current" data-id="element-186" />)}
              </div>
              <p className="text-gray-700 text-base mb-4 italic" data-id="element-187">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between border-t border-gray-50 pt-3" data-id="element-188">
                <div data-id="element-189">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-190">
                    {review.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-191">
                    {review.role} · {review.city}
                  </p>
                </div>
                <div className="flex items-center gap-1 text-xs font-medium text-green-600 bg-green-50 px-2 py-1 rounded-full" data-id="element-192">
                  <CheckCircle className="w-3 h-3" data-id="element-193" />
                  Compra verificada
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-3" data-id="element-194">
          {shortReviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4 + index * 0.05
        }} className="bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100 text-sm font-medium text-gray-700 flex items-center gap-2" data-id="element-195">
              <Star className="w-4 h-4 text-gold fill-current" data-id="element-196" />"{review}"
            </motion.div>)}
        </div>
      </div>
    </section>;
}